import { buildInvoicePdfDocumentDefinition } from "./buildInvoicePdfDocument";
import { exportReportPdf } from "../shared/pdfMakeClient";
import { buildInvoicePdfFilename } from "../shared/reportPdfFilenames";
import { prepareReportPdfBranding } from "../../helpers/prepareReportPdfBranding";

export async function downloadInvoiceReportPdf(reportModel, { branding } = {}) {
  if (!reportModel) {
    throw new Error("Report model is required");
  }

  const { branding: resolvedBranding, logoDataUrl } =
    await prepareReportPdfBranding(branding);

  const docDefinition = buildInvoicePdfDocumentDefinition(reportModel, {
    logoDataUrl,
    branding: resolvedBranding,
  });

  const filename = buildInvoicePdfFilename(reportModel);

  await exportReportPdf(
    docDefinition,
    filename,
    `Invoice — ${reportModel.header?.invoiceNumber || "Report"}`,
  );
}
